module.exports = __webpack_public_path__ + "img/ecu_banner_tr.83433fe8.jpg";